import { useCallback } from "react";
import { useIntl } from "react-intl";

export const useLanguagesList = () => {
  const intl = useIntl();
  const getLanguagesList = useCallback(
    () =>
      ["es", "en", "de", "pt", "fr", "it"].map((lang) => ({
        value: lang,
        label: intl.formatMessage({
          id: `languages.${lang}`,
        }),
      })),
    []
  );

  return { getLanguagesList };
};
